module.exports = __webpack_public_path__ + "img/calendar.a714b81b.jpeg";